import { WatchQueryFetchPolicy } from '@apollo/client'
import { FoldersDocument, FoldersQuery, FoldersQueryVariables } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Folder = FoldersQuery['documents']['folders'][number]

export const useGetFolders = (
  variables: FoldersQueryVariables,
  fetchPolicy?: WatchQueryFetchPolicy
) => {
  const { data, loading } = useQuery(FoldersDocument, { variables, fetchPolicy })

  return {
    folders: data?.documents.folders ?? [],
    loading: loading,
  }
}
